export const appendQuerystringParams = (link: string, searchParams: URLSearchParams)=> {
    try {
        // append querystring params to fotoscape link
        const url = new URL(link);
        const params = url.searchParams;
        for (const sp of searchParams.entries()) {
          if (sp[0] !== 'medium') {
            params.set(sp[0], sp[1]);
          }
        }
        return url.toString();
    } catch (e) {
        console.error(`Invalid URL in lookbook ${link}, cannot append search params`)
    }
    return link;
}
